import { ILottie } from '@/shared/lib/types';

export type EcosystemItem = {
    title: string;
    description: string;
    lottie: ILottie;
    href?: string;
};

export const DEFAULT_ECOSYSTEM_ITEMS: EcosystemItem[] = [
    {
        title: 'Expo',
        description: 'Главное B2B-пространство',
        lottie: {
            src: '/img/lottie/expo/expo.json',
        },
        href: '/participation/visitors/',
    },
    {
        title: 'Forum',
        description: 'Центр стратегического развития',
        lottie: {
            src: '/img/lottie/forum/forum.json',
        },
        href: '/participation/participants/',
    },
    {
        title: 'LIVE',
        description: 'Источник вдохновения и роста',
        lottie: {
            src: '/img/lottie/live/live.json',
        },
        href: '/events/tnf-live/',
    },
];
